import SectionCard from "@buildpy/ui/section-card";
import { CHANGE_ORDER_STATUS_LABEL } from "@buildpy/core/modules/change-order/types";
import ChangeOrderDocument from "@/modules/change-order/ui/change-order-document";
import { changeOrderPath } from "@buildpy/core/modules/change-order/view";
import A4Fit from "@/modules/print/a4-fit";
import PrintPreviewShell from "@/modules/print/print-preview-shell";
import type { ChangeOrderPrintView } from "@buildpy/core/views/g2b/change-order-print";

// 변경계약서 인쇄 — 보낸 뒤로는 굳은 문서, 작성 중이면 지금 값으로 지은 미리보기.
const Page = ({ data }: { data: ChangeOrderPrintView }) => {
  const { contract, co, preview } = data;

  return (
    <PrintPreviewShell
      closeHref={changeOrderPath(contract.id, co.id)}
      printable={Boolean(preview.data)}
      subtitle={`계약 ${contract.contract_no} · ${co.title}`}
      title={`변경공사 ${co.seq}차 · ${CHANGE_ORDER_STATUS_LABEL[co.status]}`}
    >
      {preview.data ? (
        <A4Fit>
          <ChangeOrderDocument data={preview.data} docHash={preview.draft ? null : co.doc_hash} draft={preview.draft} />
        </A4Fit>
      ) : (
        <SectionCard as="p" className="mx-auto max-w-md text-center text-sm" data-testid="change-order-print-empty">
          {preview.error ?? "보내거나 승인하기 전에 파기돼 찍을 문서가 없습니다."}
        </SectionCard>
      )}
    </PrintPreviewShell>
  );
};

export default Page;
